import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

import { usePhoneNumberDeleteMutation } from '@/query/phone-number.query';

import type { PhoneNumberConfiguration } from '@/types/phone-number.type';

type Props = {
  toggle: () => void;
  phoneNumber: PhoneNumberConfiguration;
};

export const DeletePhoneNumber = ({ toggle, phoneNumber }: Props) => {
  const mutation = usePhoneNumberDeleteMutation({
    onSuccess: () => {
      toggle();
    },
  });

  return (
    <AlertDialog open={true} onOpenChange={toggle}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This will permanently delete the Phone number{' '}
            <strong>{phoneNumber?.phone_number}</strong>. This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            type="button"
            disabled={mutation.isPending}
            onClick={() => {
              mutation.mutate(phoneNumber.id);
            }}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
